import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box
      sx={{
        p: 2,
        textAlign: 'center',
        color: 'white',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(5px)',
        mt: 'auto',
      }}
    >
      <Typography variant="body2" sx={{ fontSize: '0.9rem', opacity: 0.85 }}>
        Version 1.2.2 | © 2026 TX Park Hoppers. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;